module.exports = __webpack_public_path__ + "img/Time.e87d583d.svg";